import { usePlayerContext } from "app/context/player.context";
import { playerActions, selectPlayerState } from "app/store/slices/player";
import { useAppDispatch, useAppSelector } from "app/store/store";
import useMetaDescription from "app/utils/getMetaDescription";
import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useGetPillowRadio } from "services-hooks/hooks";

const PlayerPage: NextPage = () => {
  const router = useRouter();
  const { setPlayerEnabled, setFullscreenPlayerInitialyOpen, httpMode, setHttpMode } =
    usePlayerContext();
  const getMetaDescription = useMetaDescription();
  const dispatch = useAppDispatch();
  const permalink =
    typeof router.query.permalink === "string"
      ? router.query.permalink
      : router.query.permalink?.join("/");
  const {data} = useGetPillowRadio(permalink || '')
  
  useEffect(() => {
    setHttpMode(true);
  }, []);
  useEffect(() => {
    setFullscreenPlayerInitialyOpen(true);

    const activeCategory = data?.data.body?.content;

    setPlayerEnabled(true);
    dispatch(
      playerActions.selectTrack({
        category: activeCategory || { permalink },
        podcast: null,
      })
    );
  }, [data]);

  return (
    <div>
      <Head>{getMetaDescription()}</Head>
    </div>
  );
};

export default PlayerPage;